<template>
    <v-ons-page>
        <div class="content-inner content-inner-fill">
            <v-ons-list v-if="outlet">
                <div class="main-header main-header-spaced">Information</div>
                <v-ons-list-item modifier="chevron" tappable v-on:click="app.openMap(outlet.address_lines)">
                    <div class="center">Address</div>
                    <div class="right">{{ outlet.address_lines.join(', ') }}</div>
                </v-ons-list-item>
                <v-ons-list-item modifier="chevron" tappable v-show="helpers.stringEmpty(outlet.phone_no) == false"
                                 v-on:click="app.openPhone(outlet.phone_no)">
                    <div class="center">Phone</div>
                    <div class="right">{{ outlet.phone_no }}</div>
                </v-ons-list-item>
                <v-ons-list-item modifier="chevron" tappable v-show="helpers.stringEmpty(outlet.contact_email) == false"
                                 v-on:click="app.openEmail(outlet.contact_email)">
                    <div class="center">Email</div>
                    <div class="right">{{ outlet.contact_email }}</div>
                </v-ons-list-item>

                <div class="main-header main-header-spaced">Order options</div>

                <v-ons-list-item v-if="outlet.supports_collection" class="list-item-fulfillment-type">
                    <div class="left">
                        <i class="fal fa-shopping-basket" aria-hidden="true"/>&nbsp;
                        <span>Collection</span>
                    </div>
                    <div class="center">
                        <span>{{ getDescriptionText('collection') }}</span>
                    </div>
                </v-ons-list-item>
                <v-ons-list-item v-if="outlet.supports_delivery" class="list-item-fulfillment-type">
                    <div class="left">
                        <span>
                            <i class="fal fa-car" aria-hidden="true"/>&nbsp;
                            Delivery
                        </span>
                    </div>
                    <div class="center">
                        <span>
                            {{ getDescriptionText('delivery') }}
                        </span>
                        <template v-if="outlet.delivery_postcodes.length > 0 && outlet.delivery_additional_radius_enabled == false">
                            <div class="postcode-list">
                                Always available within the following postcodes:
                                <ul>
                                    <li v-for="delivery_postcode in outlet.delivery_postcodes">
                                        {{ delivery_postcode.postcode.toUpperCase() }}
                                    </li>
                                </ul>
                            </div>
                        </template>
                    </div>
                </v-ons-list-item>
                <v-ons-list-item v-if="outlet.supports_dropoff" class="list-item-fulfillment-type">
                    <div class="left">
                        <i class="fal fa-user" aria-hidden="true"/>&nbsp;
                        {{ outlet.dropoff_label }}
                    </div>
                    <div class="center">
                        <span>
                            {{ getDescriptionText('dropoff') }}
                        </span>
                    </div>
                </v-ons-list-item>

            </v-ons-list>
        </div>
    </v-ons-page>
</template>

<script>
    import { mapGetters, mapMutations } from 'vuex'

    import { default as WhenOutletLoadedMixin } from '../../../mixins/whenoutletloaded'

    export default {

        mixins: [WhenOutletLoadedMixin],

        mounted(){

        },

        data(){
            return {
                app: this.$root.$data.app,
            }
        },

        methods: {

            whenOutletLoaded(){


            },

            getDescriptionText(fulfillment_type) {

                fulfillment_type = fulfillment_type.toLowerCase()

                if (this.outlet == null)
                    return ''

                const is_delivery = fulfillment_type == 'delivery'
                const delivery_calculated = is_delivery && this.outlet.delivery_additional_radius_enabled

                const curr_symbol = this.outlet.currency_symbol

                const text = []

                // Order minimum
                const order_min = this.outlet[`${fulfillment_type}_minimum_order`]
                if (order_min > 0)
                    text.push(`Available for orders over ${this.filters.money(order_min, true, curr_symbol)}.`)
                else
                    text.push('No minimum spend.')

                // Add delivery cost calculated message
                if (is_delivery && delivery_calculated) {
                    text.push('Cost calculated at checkout based on your location and order total.')
                }
                // Otherwise include meta charge
                else {
                    const meta_charge = parseFloat(is_delivery ? this.outlet.delivery_charge : this.outlet[`${fulfillment_type}_service_charge`])
                    const meta_charge_cutoff = is_delivery ? this.outlet.delivery_charge_cutoff : this.outlet[`${fulfillment_type}_service_charge_cutoff`]
                    const meta_charge_is_percentage = is_delivery ? false : this.outlet[`${fulfillment_type}_service_charge_is_percentage`]
                    const meta_charge_name = is_delivery ? 'delivery charge' : this.outlet[`${fulfillment_type}_service_charge_label`]
                    if (meta_charge > 0) {
                        let meta_charge_message = meta_charge_is_percentage ? `${meta_charge}%` : this.filters.money(meta_charge, true, curr_symbol)
                        meta_charge_message += ` ${meta_charge_name}`
                        if (meta_charge_cutoff > 0)
                            meta_charge_message += ` for orders under ${this.filters.money(meta_charge_cutoff, true, curr_symbol)}`
                        meta_charge_message += '.'
                        text.push(meta_charge_message)
                    }
                }

                return text.join(' ')
            }
        },

        computed: {
            ...mapGetters([
                'outlet',
            ]),
        },

    }
</script>

<style scoped>
     .list-item-fulfillment-type .left {
         min-width: 100px;
     }
</style>


// WEBPACK FOOTER //
// src/js/components/outlets/tabs/outlet_info.vue